// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2G4Uz","content":"LayoutSettings_content__3SrFl"};